export const MAX_HOURLY_PRICE = 110;
export const BATCH_HOURLY_PRICE_WARNING_THRESHOLD = 45;
export const TEACHER_MIN_HOURLY_PRICE = 30;

export const MAX_LESSON_HOURS = 2;
export const MIN_LESSON_HOURS = 0.25;

export const MAX_STUDIO_PRICE = 25;
export const MIN_STUDIO_PRICE = 0;
export const PERSONAL_STUDIO_LABEL = "Mon studio perso";
